<template>
  <transition name="slide-down">
    <div v-if="showAlert" class="alert-container">
      <div class="alert" :class="alertType">
        {{ alertMessage }}
      </div>
    </div>
  </transition>
</template>
<script>
import languageMixins from "@/mixins/language/language-mixins";
import alertComposer from "@/composables/useAlert";

export default {
  mixins: [languageMixins, alertComposer],
};
</script>

<style lang="scss">
@import "@/public/scss/components/common/alert.scss";
</style>
